<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="nextpara"> </p>
<p class="Dedication"> </p>
<p class="Dedication"> </p>
<p class="Dedication"> </p>
<p class="Dedication"> </p>
<p class="Dedication"> </p>
<p class="Dedication">For</p>
<p class="Dedication">Louise - Ewald - Andy</p>
<p class="Dedication _idGenParaOverride-1">with love and gratitude</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NothingsWrong-3.vue?664658e6